// Central registry for tool slugs per language + SEO metadata.
// Used by App.js (routes), ToolsHubPage (cards), _ToolLayout (back link), and tool pages (meta).

export const TOOL_SLUGS = {
  geo: { tr: 'ai-gorunurluk-checkup', en: 'ai-visibility-checkup' },
  rakip: { tr: 'rakip-radari', en: 'competitor-radar' },
  rapor: { tr: 'rapor-analitik', en: 'report-analytics' },
  fiyat: { tr: 'fiyatlama-motoru', en: 'pricing-engine' },
};

// Locale path prefixes
export const TOOLS_BASE = { tr: '/araclar', en: '/tools' };

export const toolPath = (key, lang) => `${TOOLS_BASE[lang]}/${TOOL_SLUGS[key][lang]}`;

export const toolsHubPath = (lang) => TOOLS_BASE[lang];

// Per-tool SEO descriptions (concise, keyword-rich)
export const TOOL_SEO = {
  geo: {
    tr: {
      title: 'AI Görünürlük Checkup — Ücretsiz | GrowthRIQ',
      description: 'ChatGPT, Perplexity ve Gemini sizi öneriyor mu? Markanızın AI arama motorlarındaki görünürlüğünü 2 dakikada ücretsiz ölçün.',
    },
    en: {
      title: 'AI Visibility Checkup — Free | GrowthRIQ',
      description: 'Are ChatGPT, Perplexity, and Gemini recommending you? Measure your brand visibility in AI search engines in 2 minutes — free.',
    },
  },
  rakip: {
    tr: {
      title: 'Rakip Radarı — Ücretsiz Rakip Analizi | GrowthRIQ',
      description: 'Trendyol, Amazon, Shopify rakiplerinizi anonim olarak karşılaştırın. Fiyat, içerik, SEO açıklarını AI ile dakikalar içinde görün.',
    },
    en: {
      title: 'Competitor Radar — Free Competitor Analysis | GrowthRIQ',
      description: 'Anonymously benchmark your Trendyol, Amazon, Shopify rivals. Spot price, content, and SEO gaps in minutes with AI.',
    },
  },
  rapor: {
    tr: {
      title: 'Rapor Analitik — Marketplace Rapor Okuyucusu | GrowthRIQ',
      description: 'Trendyol veya Hepsiburada raporunuzu yükleyin; AI kazanımları, riskleri ve aksiyon noktalarını çıkarsın. Ücretsiz.',
    },
    en: {
      title: 'Report Analytics — Marketplace Report Reader | GrowthRIQ',
      description: 'Upload your Trendyol or Hepsiburada report; let AI extract wins, risks, and action items. Free.',
    },
  },
  fiyat: {
    tr: {
      title: 'Fiyatlama Motoru — Akıllı Satış Fiyatı | GrowthRIQ',
      description: 'Maliyet, kanal komisyonu ve hedef marjınıza göre Trendyol, Amazon ve Shopify için önerilen satış fiyatını ücretsiz hesaplayın.',
    },
    en: {
      title: 'Pricing Engine — Smart Sell-Price Calculator | GrowthRIQ',
      description: 'Get the recommended sell-price for Trendyol, Amazon, and Shopify from your cost, channel fee, and target margin — free.',
    },
  },
};

export const HUB_SEO = {
  tr: {
    title: 'Ücretsiz E-Ticaret Büyüme Araçları | GrowthRIQ',
    description: 'GrowthRIQ ücretsiz e-ticaret araçları: AI görünürlük checkup, rakip radarı, rapor analitik, fiyatlama motoru. Tek tıkla AI iç görüsü.',
  },
  en: {
    title: 'Free E-Commerce Growth Tools | GrowthRIQ',
    description: 'GrowthRIQ free e-commerce tools: AI visibility checkup, competitor radar, report analytics, pricing engine. One-click AI insights.',
  },
};
